import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1251.65412,1.13686838e-13 C1296.15294,1.13686838e-13 1339.86118,18.0705882 1371.37176,49.5811765 L1371.37176,49.5811765 L1700.59529,378.804706 C1732.55765,410.767059 1750.17647,453.345882 1750.17647,498.522353 L1750.17647,498.522353 L1750.17647,1920 L169,1920 L169,1.13686838e-13 Z M1185.47059,112.941176 L281.941176,112.941176 L281.941176,1807.05882 L1637.23529,1807.05882 L1637.23529,564.705882 L1185.47059,564.705882 L1185.47059,112.941176 Z M1298.41176,136.32 L1298.41176,451.764706 L1613.85647,451.764706 L1298.41176,136.32 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M900.497412,677.669647 C927.264471,677.669647 950.869176,690.319059 968.488,715.504941 C1010.38918,774.573176 1007.45271,837.481412 991.979765,922.187294 C986.671529,951.326118 992.092706,980.803765 1008.24329,1005.312 C1031.05741,1040.09788 1063.92329,1087.98494 1096.22447,1128.53082 C1119.94212,1158.46024 1156.42212,1174.38494 1193.35388,1169.41553 C1217.07153,1166.14024 1245.64565,1163.42965 1275.01035,1163.42965 C1406.02212,1163.42965 1396.19624,1210.18729 1408.05506,1253.10494 C1414.60565,1279.08141 1411.33035,1301.78259 1397.89035,1318.61082 C1381.17506,1341.312 1346.728,1353.05788 1296.35624,1353.05788 C1240.56329,1353.05788 1222.15388,1343.57082 1173.58918,1328.09788 C1146.14447,1319.28847 1117.68329,1317.48141 1089.89976,1324.82259 C1034.44565,1339.27906 942.963294,1361.30259 866.615059,1371.80612 C825.843294,1377.45318 788.798588,1398.46024 764.177412,1432.68141 C708.723294,1509.48141 657.335059,1581.19906 575.904471,1581.19906 C554.897412,1581.19906 535.584471,1573.632 519.659765,1558.49788 C496.168,1535.00612 486.116235,1508.91671 491.085647,1478.64847 C504.864471,1385.69788 619.160941,1333.85788 687.151529,1296.02259 C703.189176,1287.10024 715.838588,1273.43435 723.744471,1256.49318 L723.744471,1256.49318 L831.603294,1023.26965 C839.283294,1006.89318 841.655059,988.709647 838.831529,970.752 C826.295059,891.693176 807.772706,758.761412 857.579765,698.676706 C868.535059,685.236706 883.669176,677.669647 900.497412,677.669647 Z M921.052706,1017.62259 C877.796235,1144.22965 801.335059,1281.90494 791.057412,1297.94259 C883.330353,1254.57318 1066.97271,1232.66259 1066.97271,1232.66259 C974.586824,1143.66494 921.052706,1017.62259 921.052706,1017.62259 Z"
}));

var IconPdfLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPdfLine, _Component);

  var _super = _createSuper(IconPdfLine);

  function IconPdfLine() {
    _classCallCheck(this, IconPdfLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPdfLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPdf",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPdfLine.displayName = "IconPdfLine";
  return IconPdfLine;
}(Component);

IconPdfLine.glyphName = 'pdf';
IconPdfLine.variant = 'Line';
IconPdfLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPdfLine;
export { IconPdfLine };